<div obgResizeObserver (resize)="onResize($event)">
	<div class="obg-footer-container">
		<obg-compact-breadcrumb *ngIf="breadcrumbList" [breadcrumbList]="breadcrumbList"></obg-compact-breadcrumb>
		<section class="obg-footer-seo-content" *ngIf="!hideSeo">
			<obg-page-seo-content-container ngSkipHydration></obg-page-seo-content-container>
		</section>

		<obg-language-selector test-id="language-dropdown" *ngIf="!hideLanguageSelector"></obg-language-selector>

		<footer name="payment-providers">
			<obg-icon-list
				*ngIf="socialMediaIcons$ | async as socialMediaIcons"
				[icons]="socialMediaIcons"
				[titleText]="'footer.social-network.title' | translate"
				[uiInteraction]="socialMediaTrackingData"
			>
			</obg-icon-list>

			<ng-container *ngIf="gameProviderIcons$ | async as gameProviderIcons">
				<obg-icon-list
					*ngIf="isGameProvidersVisible"
					[icons]="gameProviderIcons"
					[uiInteraction]="gameProviderTrackingData"
				>
				</obg-icon-list>
			</ng-container>

			<section class="obg-footer-awards" *ngIf="isFooterAwardIconsEnabled && (awardIcons$ | async) as awardIcons">
				<div class="obg-footer-awards-content">
					<obg-icon-list [icons]="awardIcons" [uiInteraction]="awardTrackingData"> </obg-icon-list>
				</div>
			</section>

			<ng-container *ngIf="sponsorshipIcons$ | async as sponsorshipIcons">
				<obg-icon-list
					[icons]="sponsorshipIcons"
					[titleText]="'footer.sponsorship.title' | translate"
					[titleEnabled]="isSponsorshipTitleEnabled"
					[iconEnabled]="isSponsorshipIconEnabled"
					[titleIconImageKey]="'general.footer.sponsorship.title-icon'"
					[uiInteraction]="sponsorsTrackingData"
				>
				</obg-icon-list>
			</ng-container>

			<ng-container *ngIf="paymentIcons$ | async as paymentIcons">
				<obg-icon-list
					*ngIf="isPaymentVisible"
					[icons]="paymentIcons"
					[uiInteraction]="paymentTrackingData"
					data-test-id="payment-providers"
				>
				</obg-icon-list>
			</ng-container>

			<ng-container *ngIf="(megaMenu$ | async) as megaMenuColumns">
				<section class="obg-footer-mobile-menu" *ngIf="isBreakpointMobile; else desktopFooterMenu">
					<div>
						<obg-mobile-menu-item-list
							*ngFor="let column of megaMenuColumns; trackBy: trackByKey"
							[items]="column.columnItems"
							[uiInteraction]="productLinksTrackingData"
							[titleText]="column.title"
						>
						</obg-mobile-menu-item-list>
					</div>
				</section>

				<ng-template #desktopFooterMenu>
					<section class="obg-footer-product-info">
						<div>
							<obg-menu-item-list
								*ngFor="let column of megaMenuColumns; trackBy: trackByKey"
								[orientation]="productInfoItemsOrientation"
								[items]="column.columnItems"
								[uiInteraction]="productLinksTrackingData"
								[titleText]="column.title"
							>
							</obg-menu-item-list>
						</div>
					</section>
				</ng-template>
			</ng-container>

			<obg-icon-list
				class="obg-footer-regulation-icon-list"
				[class.intrinsic-size]="isRegulatoryIconsFullSize"
				*ngIf="regulationIcons$ | async as regulationIcons"
				[icons]="regulationIcons"
				[uiInteraction]="regulationTrackingData"
			>
			</obg-icon-list>

			<section
				class="obg-footer-responsible-gaming-content-mobile"
				*ngIf="isMobile && (isResponsibleGamingVisible$ | async)"
				[innerHtml]="'footer.responsible-gaming.content' | translate"
			></section>

			<div class="obg-footer-mobile-licenses" *ngIf="hideExtendedLicencesSection">
				<obg-footer-license></obg-footer-license>
			</div>

			<ng-container *ngIf="!isDesktop && isHgc && (eepdLogoIcon$ | async) as eepdIcon">
				<ng-template [ngTemplateOutlet]="hgcDisclaimer" [ngTemplateOutletContext]="{ eepdIcon: eepdIcon }">
				</ng-template>
			</ng-container>

			<section class="obg-footer-responsible-gaming">
				<div class="obg-footer-responsible-gaming-container">
					<div class="obg-footer-responsible-gaming-image">
						<a
							*ngIf="securityLeftIcon$ | async as securityLeftIcon"
							[href]="securityLeftIcon.link?.url"
							[target]="securityLeftIcon.link?.target"
						>
							<obg-lazy-image
								*ngIf="securityLeftIcon?.logo"
								[src]="securityLeftIcon.logo?.url"
								[alt]="securityLeftIcon.logo?.altText"
							>
							</obg-lazy-image>
						</a>
					</div>
					<div class="obg-footer-responsible-gaming-info">
						<p
							class="copyright"
							[innerHtml]="'footer.copyright' | devicePostfix | translate: { currentYear:currentYear }"
						></p>

						<obg-icon-list
							class="obg-footer-responsible-gaming-icon-list"
							*ngIf="securityIcons$ | async as securityIcons"
							[ngClass]="{ 'enable-scale-effect' : isIconListScaleEffectEnabled(jurisdiction) }"
							[titleText]="'footer.responsible-gaming' | translate"
							[icons]="securityIcons"
							[uiInteraction]="responsibleGamingTrackingData"
						>
						</obg-icon-list>

						<div
							class="obg-footer-responsible-gaming-info-container"
							*ngIf="isResponsibleGamingInfoEnabled"
						>
							<p
								class="obg-footer-responsible-gaming-info-header"
								[innerHtml]="'footer.responsible-gaming.information.text.header'| translate"
							></p>
							<p
								class="obg-footer-responsible-gaming-info-text"
								[innerHtml]="'footer.responsible-gaming.information.text'| translate"
							></p>
						</div>

						<obg-menu
							*ngIf="footerMenu$ | async as footerMenuItems"
							[menuItems]="footerMenuItems"
							[uiInteraction]="responsibleGamingTrackingData"
							(selectedItem)="selectedItem($event)"
						>
						</obg-menu>
					</div>
				</div>
			</section>

			<ng-template #hgcDisclaimer let-eepdIcon="eepdIcon">
				<section>
					<a
						*ngIf="eepdIcon?.logo"
						data-test-id="footer-hgc-disclaimer"
						[href]="eepdIcon.link?.url"
						[target]="eepdIcon.link?.target"
						class="obg-footer-hgc-regulation-container"
					>
						<obg-lazy-image [src]="eepdIcon.logo?.url" [alt]="eepdIcon.logo?.altText"> </obg-lazy-image>
						<p [innerHTML]="'footer.eepd' | devicePostfix | translate"></p>
					</a>
				</section>
			</ng-template>

			<ng-container *ngIf="isDesktop && isHgc && (eepdLogoIcon$ | async) as eepdIcon">
				<ng-template [ngTemplateOutlet]="hgcDisclaimer" [ngTemplateOutletContext]="{ eepdIcon: eepdIcon }">
				</ng-template>
			</ng-container>

			<section
				class="obg-footer-responsible-gaming-content"
				*ngIf="!isMobile && (isResponsibleGamingVisible$ | async)"
			>
				<div
					class="obg-footer-responsible-gaming-content-description"
					[innerHtml]="'footer.responsible-gaming.content' | translate"
				></div>
			</section>

			<section
				class="obg-footer-licenses"
				*ngIf="!hideExtendedLicencesSection && (footerLicenses$ | async) as footerLicenses"
				test-id="legal-content-text"
			>
				<div *ngFor="let license of footerLicenses; trackBy: trackByKey">
					<a
						[href]="license.link?.url"
						[target]="license.link?.target"
						[obgInteraction]="licensesTrackingData"
					>
						<obg-lazy-image *ngIf="license.icon" [src]="license.icon.url" [alt]="license.icon.altText">
						</obg-lazy-image>
					</a>
					<p [innerHtml]="license.title"></p>
				</div>
			</section>

			<section
				class="obg-footer-last-login"
				*ngIf="(isAuthenticated$ | async) && isAams && (lastLoginMessage$ | async)"
			>
				<div class="obg-footer-last-login-content">
					<p [innerHtml]="lastLoginMessage$ | async" test-id="last-login-date"></p>
				</div>
			</section>

			<div class="obg-footer-other-links" *ngIf="otherLinksMenu$ | async as otherLinksMenu">
				<obg-menu [menuItems]="otherLinksMenu" [uiInteraction]="otherClicksTrackingData"> </obg-menu>
			</div>
		</footer>
	</div>
</div>
